import React from 'react';
import styles from '../style/HomePage.module.css';

function PrivacyPage() {
  return (
    <div className={styles.pageContainer} style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', color: 'var(--text-primary)' }}>
      <h1>Datenschutzerklärung</h1>
      <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>

      <section style={{ marginTop: '2rem' }}>
        <h2>1. Datenschutz auf einen Blick</h2>
        <h3>Allgemeine Hinweise</h3>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
          wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
        </p>
        <h3>Datenerfassung auf dieser Website</h3>
        <p>
          <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
          Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen:
          <br /><br />
          <strong>AWN GmbH</strong><br />
          Konrad-Zuse-Str. 1<br />
          84579 Unterneukirchen<br />
          Deutschland
        </p>
        <p>
          <strong>Wie erfassen wir Ihre Daten?</strong><br />
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. 
          Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular oder bei der Registrierung eingeben.
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. 
          Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>2. Hosting und Content Delivery Networks (CDN)</h2>
        <h3>Externes Hosting (Supabase / Cloud-Dienste)</h3>
        <p>
          Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, 
          werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, 
          Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten, 
          die über eine Website generiert werden, handeln.
        </p>
        <p>
          Die Nutzung des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden 
          (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots 
          durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
        <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
        <p>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
          Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. 
          Sie können Ihre Cookie-Einstellungen auch jederzeit über den Link "Cookie-Einstellungen" im Footer ändern.
        </p>
        <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
        <p>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde zu.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>4. Datenerfassung auf dieser Website</h2>
        <h3>Cookies</h3>
        <p>
          Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. 
          Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
        </p>
        <p>
          <strong>Notwendige Cookies:</strong> Technische Cookies, die für den Betrieb der Seite notwendig sind (z.B. Login-Status, Warenkorb).<br />
          <strong>Einwilligungspflichtige Cookies:</strong> Analyse- oder Marketing-Cookies (z.B. Google Analytics) werden nur gesetzt, 
          wenn Sie uns im Cookie-Banner Ihre ausdrückliche Erlaubnis geben.
        </p>

        <h3>Registrierung auf dieser Website</h3>
        <p>
          Sie können sich auf unserer Website registrieren, um zusätzliche Funktionen auf der Seite zu nutzen. 
          Die dazu eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes, 
          für den Sie sich registriert haben. Die bei der Registrierung abgefragten Pflichtangaben müssen vollständig angegeben werden. 
          Anderenfalls werden wir die Registrierung ablehnen.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>5. Analyse-Tools und Werbung</h2>
        <h3>Google Analytics</h3>
        <p>
          Sofern Sie eingewilligt haben, nutzen wir Google Analytics, einen Webanalysedienst der Google Ireland Limited. 
          Dieser Dienst wird nur aktiviert, wenn Sie im Cookie-Banner auf "Akzeptieren" geklickt haben.
          Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website durch Sie ermöglichen.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>6. Zahlungsdienstleister</h2>
        <h3>Stripe</h3>
        <p>
          Wir bieten die Möglichkeit der Bezahlung via Stripe an. Anbieter für Kunden innerhalb der EU ist die 
          Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland.
        </p>
        <p>
          Bei Zahlungen via Stripe werden Ihre Zahlungsdaten an Stripe übermittelt. 
          Die Übermittlung Ihrer Daten an Stripe erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragsabwicklung) 
          sowie auf Grundlage unseres berechtigten Interesses an einem sicheren und effizienten Bezahlvorgang (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
        <p>
          Details hierzu entnehmen Sie der Datenschutzerklärung von Stripe unter: <br />
          <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">https://stripe.com/de/privacy</a>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>7. Kontakt</h2>
        <p>
          Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, 
          Sperrung oder Löschung von Daten wenden Sie sich bitte an:
          <br /><br />
          <strong>E-Mail:</strong> info@awn-gmbh.de<br />
          <strong>Telefon:</strong> +49 (0) 8634 - 624 336
        </p>
      </section>
    </div>
  );
}

export default PrivacyPage;